if (!customElements.get('product-bundle-form')) {
  customElements.define('product-bundle-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.maxNumber = this.dataset.maxproduct;
      this.maxfreeProduct = this.dataset.maxfreeproduct;
      this.enableFreeProduct = this.dataset.freeproductenabled;

      this.enabledofferet = this.dataset.enabledofferet;
      this.enabledofferetProducts = this.dataset.offeretproducts;
      
      this.quantityCounter = 0;
      this.freeQuantityCounter = 0;
      
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.quantityButtons = this.querySelectorAll(".quantity-button");
      this.quantityBoxOpenrButtons = this.querySelectorAll(".custom-item-qty-opener");
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
       if(this.enableFreeProduct === 'true'){
        this.defaultCustomButtom = this.querySelector(".custom-default-button");
         this.stepBackSelector = this.querySelector(".first-step-back"); 
       }else{
         this.defaultCustomButtom = this.submitButton;
       }

      this.quantityButtonsFree = this.querySelectorAll(".quantity-button-free");
      this.quantityBoxOpenrButtonsFreee = this.querySelectorAll(".custom-item-qty-opener-free");
       
      this.initEventListeners();
    }
    initEventListeners(){
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.quantityButtons.forEach( (el) => {
        el.addEventListener("click",this.quantityChangeHandler.bind(this));
      });
      this.quantityBoxOpenrButtons.forEach( (el) => {
        el.addEventListener("click",this.openQuantityBox.bind(this));
      });
       if(this.enableFreeProduct === 'true'){
        this.defaultCustomButtom.addEventListener("click",this.defaultButtonHandler.bind(this));
         
         this.quantityButtonsFree.forEach( (el) => {
          el.addEventListener("click",this.quantityChangeHandlerFree.bind(this));
        });
        this.quantityBoxOpenrButtonsFreee.forEach( (el) => {
          el.addEventListener("click",this.openQuantityBoxFree.bind(this));
        });
         this.stepBackSelector.addEventListener("click",this.getStepOne.bind(this));
         if(this.querySelectorAll(`div.product-bundle-items-wrapper-free[data-size="1"]`).length > 0){
           this.querySelector("div.product-bundle-items-wrapper-free .custom-item-qty-opener-free").classList.add("hidden");
           this.querySelector("div.product-bundle-items-wrapper-free .product-bundle-item-quantity-wrapper").classList.add("hidden");
         }
       }
    }
    getStepOne(evt){
       if(this.enableFreeProduct === 'true'){
         this.querySelector(".bundle-product-setp-wrapper").classList.remove("hidden");
         if(this.closest(".custom-collection-packs-shopify-section-product-details")){
           this.closest(".custom-collection-packs-shopify-section-product-details").querySelector(".bundle-product-step-one").classList.remove("hidden");
           this.closest(".custom-collection-packs-shopify-section-product-details").querySelector(".free-product-step-title").classList.add("hidden");
           this.closest(".custom-collection-packs-shopify-section-product-details").querySelector(".free-product-step-offer-text-wrapper").classList.add("hidden");
         }else{
           this.closest(".custom-modal__centered.active").querySelector(".bundle-product-step-one").classList.remove("hidden");
           this.closest(".custom-modal__centered.active").querySelector(".free-product-step-title").classList.add("hidden");
           this.closest(".custom-modal__centered.active").querySelector(".free-product-step-offer-text-wrapper").classList.add("hidden");
         }
        
        this.querySelector(".bundle-product-setp-wrapper-free").classList.add("hidden");
       }
    }
    defaultButtonHandler(evt){
       if(this.enableFreeProduct === 'true'){
         this.querySelector(".bundle-product-setp-wrapper").classList.add("hidden");
         if(this.closest(".custom-collection-packs-shopify-section-product-details")){
           this.closest(".custom-collection-packs-shopify-section-product-details").querySelector(".bundle-product-step-one").classList.add("hidden");
           this.closest(".custom-collection-packs-shopify-section-product-details").querySelector(".free-product-step-title").classList.remove("hidden");
           this.closest(".custom-collection-packs-shopify-section-product-details").querySelector(".free-product-step-offer-text-wrapper").classList.remove("hidden");
         }else{
           this.closest(".custom-modal__centered.active").querySelector(".bundle-product-step-one").classList.add("hidden");
           this.closest(".custom-modal__centered.active").querySelector(".free-product-step-title").classList.remove("hidden");
           this.closest(".custom-modal__centered.active").querySelector(".free-product-step-offer-text-wrapper").classList.remove("hidden");
         }
        
        this.querySelector(".bundle-product-setp-wrapper-free").classList.remove("hidden");
      }else{
        this.form.submit();
      }
    }
    openQuantityBox(evt){
        evt.preventDefault();
        let isFilled = true;
        const parentElement = evt.target.parentElement;
        const currentParentElement = evt.target.closest('.product-bundle-item-wrapper');
        currentParentElement.querySelectorAll(".custom-option-selector").forEach( (el) => {
          if(el.value == ""){
            isFilled = false;
            el.classList.add("has-error");
          }else{
             el.classList.remove("has-error");
          }  
        });
        if(isFilled == true){
          //parentElement.querySelector(".quantity-button.plus").click();
          parentElement.querySelector(".quantity-button.plus").dispatchEvent(new Event('click'));
          parentElement.querySelector(".product-bundle-item-quantity-wrapper").classList.remove("hidden");
          evt.target.classList.add("hidden");
        
         currentParentElement.classList.add("active");
        }
    }
    connectedCallback() {
        
     }
    openQuantityBoxFree(evt){
        evt.preventDefault();
        let isFilled = true;
        const parentElement = evt.target.parentElement;
        const currentParentElement = evt.target.closest('.product-bundle-item-wrapper-free');
        currentParentElement.querySelectorAll(".custom-option-selector").forEach( (el) => {
          if(el.value == ""){
            isFilled = false;
            el.classList.add("has-error");
          }else{
             el.classList.remove("has-error");
          }  
        });
        if(isFilled == true){
          parentElement.querySelector(".quantity-button-free.plus-free").click();
          parentElement.querySelector(".product-bundle-item-quantity-wrapper").classList.remove("hidden");
          evt.target.classList.add("hidden");
        
         currentParentElement.classList.add("active");
        }
    }
    quantityChangeHandler(evt){
      evt.preventDefault();
      
      const inputElement = evt.target.parentElement.querySelector('.custom-qty-box-input');
       const currentParentElement = evt.target.closest('.product-bundle-item-button');
      const itemContentlement = currentParentElement.closest('.product-bundle-item-wrapper');
      if(evt.target.classList.contains('plus')){
        
        if(this.quantityCounter < this.maxNumber){
          inputElement.stepUp();
          this.quantityCounter++;
        }
        currentParentElement.querySelector(".display-qty").textContent= inputElement.value;
        if(inputElement.value > 0){
          evt.target.parentElement.querySelector('button.minus').removeAttribute("disabled");
        }
      }else{
        if(this.quantityCounter > 0){
          inputElement.stepDown();
          this.quantityCounter--;
          currentParentElement.querySelector(".display-qty").textContent= inputElement.value;
        }
        if(inputElement.value <= 0){
          evt.target.parentElement.querySelector('button.minus').setAttribute("disabled","disabled");
          currentParentElement.querySelector(".product-bundle-item-quantity-wrapper").classList.add("hidden");
          currentParentElement.querySelector(".custom-item-qty-opener").classList.remove("hidden");
        }
      }
      const currentInputValue = inputElement.value;
      if(currentInputValue > 0){
        itemContentlement.querySelectorAll(".mark_me-custom-bundle").forEach((el) => {
          if(el.checked == false){
           el.setAttribute("disabled","disabled"); 
           el.parentElement.classList.add("opacity-5");
            el.closest(".custom-swatches-bundle-new").querySelector(".custom-option-selector").setAttribute("disabled","disabled"); 
          el.closest(".custom-swatches-bundle-new").querySelector(".custom-option-selector").classList.add("opacity-5");
          }
        });
      }else{
        itemContentlement.querySelectorAll(".mark_me-custom-bundle").forEach((el) => {
           el.removeAttribute("disabled"); 
          el.parentElement.classList.remove("opacity-5");
           el.closest(".custom-swatches-bundle-new").querySelector(".custom-option-selector").removeAttribute("disabled"); 
          el.closest(".custom-swatches-bundle-new").querySelector(".custom-option-selector").classList.remove("opacity-5");
        });
      }
      
      this.defaultCustomButtom.querySelector("span.bundle-message .bundle-counter").textContent = `${this.quantityCounter}/${this.maxNumber}`;
      
       if(this.quantityCounter >= this.maxNumber){
         this.querySelectorAll(".product-bundle-item-wrapper").forEach( (el) => {
           const mainElement = el;
           if(el.querySelector(".custom-qty-box-input").value > 0){
             el.querySelector("button.plus").setAttribute("disabled","disabled");
             el.querySelector("button.minus").removeAttribute("disabled");
           }else{
             el.classList.add("opacity-5");
              el.querySelector("button.plus").setAttribute("disabled","disabled");
              el.querySelector("button.minus").setAttribute("disabled","disabled");
           }
           
         });
         this.defaultCustomButtom.querySelector("span.bundle-message").classList.add("hidden");
         this.defaultCustomButtom.querySelector("span.add-to-cart-message").classList.remove("hidden");
          this.defaultCustomButtom.removeAttribute("disabled");
         
       }else{
         this.querySelectorAll(".product-bundle-item-wrapper").forEach( (el) => {
           el.querySelector("button.plus").removeAttribute("disabled");
           el.classList.remove("opacity-5");
         });
         this.defaultCustomButtom.querySelector("span.add-to-cart-message").classList.add("hidden");
         this.defaultCustomButtom.querySelector("span.bundle-message").classList.remove("hidden");
         this.defaultCustomButtom.setAttribute("disabled","disabled");
       }
      
    }
    quantityChangeHandlerFree(evt){
      evt.preventDefault();
      
      const inputElement = evt.target.parentElement.querySelector('.custom-qty-box-input');
       const currentParentElement = evt.target.closest('.product-bundle-item-button');
      if(evt.target.classList.contains('plus-free')){
        
        if(this.freeQuantityCounter < this.maxfreeProduct){
          inputElement.stepUp();
          this.freeQuantityCounter++;
        }
        currentParentElement.querySelector(".display-qty").textContent= inputElement.value;
        if(inputElement.value > 0){
          evt.target.parentElement.querySelector('button.minus-free').removeAttribute("disabled");
        }
      }else{
        if(this.freeQuantityCounter > 0){
          inputElement.stepDown();
          this.freeQuantityCounter--;
          currentParentElement.querySelector(".display-qty").textContent= inputElement.value;
        }
        
        if(inputElement.value <= 0){
          evt.target.parentElement.querySelector('button.minus-free').setAttribute("disabled","disabled");
          currentParentElement.querySelector(".product-bundle-item-quantity-wrapper").classList.add("hidden");
          currentParentElement.querySelector(".custom-item-qty-opener-free").classList.remove("hidden");
        }
      }
      this.submitButton.querySelector("span.bundle-message-free .bundle-counter-free").textContent = `${this.freeQuantityCounter}/${this.maxfreeProduct}`;
      
       if(this.freeQuantityCounter >= this.maxfreeProduct){
         this.querySelectorAll(".product-bundle-item-wrapper-free").forEach( (el) => {
           const mainElement = el;
           if(el.querySelector(".custom-qty-box-input").value > 0){
             el.querySelector("button.plus-free").setAttribute("disabled","disabled");
             el.querySelector("button.minus-free").removeAttribute("disabled");
           }else{
             el.classList.add("opacity-5");
              el.querySelector("button.plus-free").setAttribute("disabled","disabled");
              el.querySelector("button.minus-free").setAttribute("disabled","disabled");
           }
           
         });
         this.submitButton.querySelector("span.bundle-message-free").classList.add("hidden");
         this.submitButton.querySelector("span.add-to-cart-message-free").classList.remove("hidden");
          this.submitButton.removeAttribute("disabled");
         
       }else{
         this.querySelectorAll(".product-bundle-item-wrapper-free").forEach( (el) => {
           el.querySelector("button.plus-free").removeAttribute("disabled");
           el.classList.remove("opacity-5");
         });
         this.submitButton.querySelector("span.add-to-cart-message-free").classList.add("hidden");
         this.submitButton.querySelector("span.bundle-message-free").classList.remove("hidden");
         this.submitButton.setAttribute("disabled","disabled");
       }
      
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if(this.querySelectorAll(".product-bundle-item-quantity-wrapper .custom-qty-box-input").length <= 0){
        return false;
      }
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const mainId = this.form.querySelector(`input[name="id"]`).value;
      const bundleId = Date.now();
      const allproperties = [];
      let items = [];
      
      let bundlerItem = 0;
      this.querySelectorAll(".product-bundle-item-quantity-wrapper .custom-qty-box-input").forEach( (el) => {
        if(el.value > 0){
          allproperties.push(el.dataset.title);
          if(el.classList.contains("free-product-input")){
            items.push({
              "id":el.dataset.vid,
              "quantity":el.value,
              "properties":{
                "_customBundleId":bundleId,
                "_isMainProduct":0,
                "_baseQty":el.value,
                "_isFreeProduct":1
              }
            });
          }else{
            items.push({
              "id":el.dataset.vid,
              "quantity":el.value,
              "properties":{
                "_customBundleId":bundleId,
                "_isMainProduct":0,
                "_baseQty":el.value
              }
            });
          }
          
          bundlerItem++;
        }
      });
      if( this.enabledofferet === 'true'){
          if(this.enabledofferetProducts){
            const enabledofferetProductsdata = this.enabledofferetProducts.split("___");
            if(enabledofferetProductsdata.length > 0){
              for(let i in enabledofferetProductsdata){
                if(enabledofferetProductsdata[i]){
                  const slitthestring = enabledofferetProductsdata[i].split("||");
                  let productTitle = slitthestring[1];
                  if(slitthestring[2]){
                    if(slitthestring[2].indexOf("Default") > -1){
                    }else{
                      productTitle = `${productTitle}:${slitthestring[2]}`
                    }
                  }
                  allproperties.push(productTitle);
                  items.push({
                    "id":slitthestring[0],
                    "quantity":1,
                    "properties":{
                      "_customBundleId":bundleId,
                      "_isMainProduct":0,
                      "_baseQty":1,
                      "_isOffertAddon":1
                    }
                  });
                }
              }
            }
          }
        }
      items.push(
        {
          "id":mainId,
          "quantity":1,
          "properties":{
            "_customBundleId":bundleId,
            "_isMainProduct":1,
            "Contenu":allproperties.join("|")
          }
        }
      );
      if(bundlerItem <= 0){
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.setAttribute("disabled","disabled");
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return false;
      }
      let formData = {
       'items':items,
        'sections':this.cart.getSectionsToRender().map((section) => section.id),
        'sections_url':window.location.pathname
      };
      
      fetch(`${routes.cart_add_url}.js`,{
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: mainId, errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: mainId});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          this.closest(".custom-modal__centered.active").classList.remove("active");
           $("body").removeClass("remove-zindex");
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
      
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}